import { Alert, Col, Datepicker, InputField, Label, Row } from "client/CommonComponents"

const CreateEditNewScan = (props:any) => {
const { handleDatesChange, handleNameChange, values, isScanSavedFlag } = props

    return(
        <Row>
            <Col xs={12} sm={12} md={6} lg={6}>
                <Label required data-attribute="CreateEditNewScan_Default_Label">M&A Scan Name</Label>
                <InputField 
                    placeholder="Enter M&A Scan Name"
                    name='scanName'
                    onChange={handleNameChange}
                    value={values?.scanName}
                    className={(values?.scanNameError ? "controlValidation form-input" : "form-input")}
                 data-attribute="CreateEditNewScan_scanName_Input" />
                {values?.scanNameError &&
                    <span className="validMessage">
                        {values?.scanNameError}
                    </span>
                }
            </Col>
            <Col xs={12} sm={12} md={6} lg={6}>
                <Label required data-attribute="CreateEditNewScan_Default_Label_2">Deal Date</Label>
                <Datepicker 
                    placeholder="MM/DD/YYYY"
                    onChangeDate={(value: any)=>handleDatesChange(value, 'dealDate')}
                    value={values?.dealDate ? new Date(values?.dealDate) : null}
                    allowTextInput={false}
                    className={(values?.dealDateError ? "controlValidation form-input" : "form-input")}
                 data-attribute="CreateEditNewScan_Default_Datepicker" />
                {values?.dealDateError &&
                    <span className="validMessage">
                        {values?.dealDateError}
                    </span>
                }
            </Col>
            <Col xs={12} sm={12} md={6} lg={6}>
                <Label required data-attribute="CreateEditNewScan_Default_Label_3">Scan Start Date</Label>
                <Datepicker 
                    placeholder="MM/DD/YYYY"
                    onChangeDate={(value: any)=>handleDatesChange(value, 'startDate')}
                    value={values?.startDate ? new Date(values?.startDate) : null}
                    allowTextInput={false}
                    className={(values?.startDateError ? "controlValidation form-input" : "form-input")}
                 data-attribute="CreateEditNewScan_Default_Datepicker_2" />
                {values?.startDateError &&
                    <span className="validMessage">
                        {values?.startDateError}
                    </span>
                }
            </Col>
            <Col xs={12} sm={12} md={6} lg={6}>
                <Label required data-attribute="CreateEditNewScan_Default_Label_4">Scan End Date</Label>
                <Datepicker 
                    placeholder="MM/DD/YYYY"
                    onChangeDate={(value: any)=>handleDatesChange(value, 'endDate')}
                    value={values?.endDate ? new Date(values?.endDate) : null}
                    allowTextInput={false}
                    className={(values?.endDateError ? "controlValidation form-input" : "form-input")}
                 data-attribute="CreateEditNewScan_Default_Datepicker_3" />
                {values?.endDateError &&
                    <span className="validMessage">
                        {values?.endDateError}
                    </span>
                }
            </Col>
            <Alert  
                type={isScanSavedFlag?.status ? 'success' : 'error' }
                text={isScanSavedFlag?.status ? 'Scan Saved Successfully' : isScanSavedFlag?.message}
                showAlert={!!isScanSavedFlag?.message}
             data-attribute="CreateEditNewScan_Default_Alerts" />     
        </Row>
    )
}

export default CreateEditNewScan